export const SOURCE_OPTIONS = [
  {
    value: 'modelsource',
    name: 'Pathways Explorer Model (dynamic data)',
    disabled: false,
  },
  {
    value: 'officialsource',
    name: 'Other sources (static data)',
    disabled: false,
  },
];

export const MODEL_SOURCE = SOURCE_OPTIONS[0].value;
export const OFFICIAL_SOURCE = SOURCE_OPTIONS[1].value;
